import { Card, CardContent } from "@/components/ui/card";
import { FeedItem } from "@/types/feed";
import UFOLayout from "@/components/cards/templates/UFOLayout";
import { SharedCardFooter } from "./shared/CardFooter";

interface FeedLayoutProps {
  post: FeedItem;
}

export function UFOFeedLayout({ post }: FeedLayoutProps) {
  const cardData = {
    title: post.title,
    description: post.description,
    imageUrl: post.imageUrl ? 
      (post.imageUrl.startsWith('http') ? post.imageUrl : `${import.meta.env.VITE_API_URL}${post.imageUrl}`)
      : undefined,
    metadata: {
      documentType: post.metadata?.documentType || 'Unknown',
      type: post.metadata?.type || 'Unknown',
      era: post.metadata?.era || 'Unknown',
      classification: post.metadata?.classification || 'Unknown',
      sourceQuality: post.metadata?.sourceQuality || 'Unknown',
      language: post.metadata?.language || 'en',
      playerName: post.metadata?.playerName || 'Anonymous',
      siteType: post.metadata?.siteType,
      entityType: post.metadata?.entityType,
      mediaType: post.metadata?.mediaType,
      artifactType: post.metadata?.artifactType
    }
  };

  return (
    <Card className="mb-4 max-w-xl bg-black p-2">
      <CardContent className="flex flex-col items-center p-0">
        <div className="w-full flex justify-center mb-4">
          <UFOLayout cardData={cardData} />
        </div>
      </CardContent>
      
      <SharedCardFooter 
        playerName={post.creator?.username}
      />
    </Card>
  );
} 